import { render, staticRenderFns } from "./DocumentCenter.vue?vue&type=template&id=d735fe66"
import script from "./DocumentCenter.vue?vue&type=script&lang=js"
export * from "./DocumentCenter.vue?vue&type=script&lang=js"
import style0 from "./DocumentCenter.vue?vue&type=style&index=0&id=d735fe66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports